module.exports = __webpack_public_path__ + "img/insta.318712cb.png";